import { marker } from "@jsverse/transloco-keys-manager/marker";
import { some } from "lodash-es";
import { RoleType } from "src/app/backend/models/role/role";
import { NavigationBarItem } from "src/app/modules/bootstrap/bootstrap-components/navigation-bar/navigation-bar-item";
import { UserService } from "src/app/services/user.service";
import { absoluteUrl } from "src/app/support/navigation";
import { sntTranslate } from "src/app/support/translate";

export function getAdminNavigationBarMenu(
  currentRoles: RoleType[],
  { userService }: { userService: UserService }
): NavigationBarItem[] {
  return filterMenuItemByRole(currentRoles, [
    {
      title: sntTranslate(marker("Dashboard")),
      url: absoluteUrl("/dashboard"),
      icon: "fa-house",
      disabled: false
    },
    {
      title: sntTranslate(marker("Domini")),
      icon: "fa-light fa-folder-open",
      url: absoluteUrl("/domains")
    },
    {
      title: sntTranslate(marker("Accounts")),
      icon: "fa-light fa-folder-gear",
      url: absoluteUrl("/accounts")
    },
    {
      title: sntTranslate(marker("Tenants")),
      icon: "fa-light fa-square-list",
      url: absoluteUrl("/tenants")
    },
    /*
    {
      title: sntTranslate(marker("Servizi")),
      icon: "fa-light fa-handshake",
      url: absoluteUrl("/services")
    },
    */
    /*
    {
      title: sntTranslate(marker("Ordini")),
      icon: "fa-light fa-list-check",
      url: absoluteUrl("/orders")
    },
    */
    {
      title: sntTranslate(marker("Esportazioni")),
      icon: "fa-light fa-file-export",
      url: absoluteUrl("/exports")
    }
  ]);
}

function filterMenuItemByRole(
  currentRoles: RoleType[],
  items: NavigationBarItem[]
): NavigationBarItem[] {
  return items.filter((x) => isMenuItemAuthorized(currentRoles, x));
}

function isMenuItemAuthorized(
  currentRoles: RoleType[],
  menu: NavigationBarItem
): boolean {
  if (menu.roles) {
    if (menu.roles.unauthorized) {
      return some(
        currentRoles,
        (role) => !menu.roles!.unauthorized!.includes(role)
      );
    }
    if (menu.roles.authorized) {
      return some(currentRoles, (role) =>
        menu.roles!.authorized!.includes(role)
      );
    }
  }

  return true;
}
